import { createContext } from 'react';

/**
 * Context values for translations in an application.
 * @typeParam T Type of translations object
 */

const defaultValues = {
  translationsWithNamespaces: {},
  defaultTranslationsWithNamespaces: {},
  language: '',
  /** @deprecated Use @see {language} */
  currentLanguage: '',
  clientFetchConfiguration: {
    baseUrl: '',
    tenant: '',
    onError: error => console.error(error)
  }
};
export const translationsContext = /*#__PURE__*/createContext(defaultValues);
//# sourceMappingURL=translationsContext.js.map